document.addEventListener("DOMContentLoaded", function () {
  window.productTabs = {
    currentPage: 1,
    currentCategory: "all",
    loading: false,
    noMoreProducts: false
  };
  const product_tabs = document.querySelectorAll(".product-tabs__nav-item");
  const mobileCategorySelect = document.querySelector(".product-tabs__mobile-nav");
  const mobileSubcategorySelect = document.querySelectorAll(".product-tabs__subnav-select");
  if (product_tabs && product_tabs.length > 0) {
    const firstCategory = product_tabs[0].dataset.category;
    window.productTabs.currentCategory = firstCategory;
    product_tabs[0].classList.add("active");
    loadProducts(firstCategory, 1, true);
    const productSubnavTabs = document.querySelectorAll(".product-tabs__subnav-item");
    product_tabs.forEach(tab => {
      tab.addEventListener("click", function () {
        const category = this.dataset.category;
        document.querySelectorAll(".product-tabs__nav-item").forEach(item => {
          item.classList.remove("active");
        });
        this.classList.add("active");
        window.productTabs.currentPage = 1;
        window.productTabs.currentCategory = category;
        window.productTabs.noMoreProducts = false;

        // Sincronizar el selector móvil con la pestaña seleccionada
        if (mobileCategorySelect) {
          mobileCategorySelect.value = category;
        }
        const thisDataNav = this.querySelector("a").getAttribute("data-nav");
        document.querySelectorAll(".product-tabs__subnav").forEach(subnav => {
          subnav.classList.remove("active");
          if (subnav.id === "product-subnav-" + thisDataNav) {
            subnav.classList.add("active");
          }
        });
        loadProducts(category, 1, true);
      });
    });
    if (productSubnavTabs) {
      productSubnavTabs.forEach(subTab => {
        subTab.addEventListener("click", function () {
          const category = this.dataset.category;
          const parentCategory = this.dataset.parent;
          document.querySelectorAll(".product-tabs__subnav-item").forEach(item => {
            item.classList.remove("active");
          });
          this.classList.add("active");
          window.productTabs.currentPage = 1;
          window.productTabs.currentCategory = category;
          window.productTabs.noMoreProducts = false;

          // Sincronizar el selector móvil con la pestaña seleccionada
          if (mobileCategorySelect) {
            mobileCategorySelect.value = category;
          }
          if (category === "all") {
            loadProducts(parentCategory, 1, true);
          } else {
            loadProducts(category, 1, true);
          }

          //loadProducts(category, 1, true);
        });
      });
    }

    // Agregar evento change al selector móvil
    if (mobileCategorySelect) {
      mobileCategorySelect.addEventListener("change", function () {
        const category = this.value;

        // Actualizar pestaña activa en la versión desktop
        document.querySelectorAll(".product-tabs__nav-item").forEach(item => {
          item.classList.remove("active");
          if (item.dataset.category === category) {
            item.classList.add("active");
          }
        });
        window.productTabs.currentPage = 1;
        window.productTabs.currentCategory = category;
        window.productTabs.noMoreProducts = false;
        document.querySelectorAll(".product-tabs__subnav-select").forEach(subnav => {
          subnav.classList.remove("active");
          if (subnav.id === "product-subnav-select-" + category) {
            subnav.classList.add("active");
          }
        });
        loadProducts(category, 1, true);
      });
    }
    if (mobileSubcategorySelect) {
      mobileSubcategorySelect.forEach(select => {
        select.addEventListener("change", function () {
          const category = this.value;
          const parentCategory = this.dataset.parent;
          document.querySelectorAll(".product-tabs__subnav-item").forEach(item => {
            item.classList.remove("active");
            if (item.dataset.category === category) {
              item.classList.add("active");
            }
          });
          window.productTabs.currentPage = 1;
          window.productTabs.currentCategory = category;
          window.productTabs.noMoreProducts = false;
          if (category === "all") {
            loadProducts(parentCategory, 1, true);
          } else {
            loadProducts(category, 1, true);
          }
        });
      });
    }
    document.getElementById("load-more-products").addEventListener("click", function () {
      if (!window.productTabs.loading && !window.productTabs.noMoreProducts) {
        window.productTabs.currentPage++;
        loadProducts(window.productTabs.currentCategory, window.productTabs.currentPage, false);
      }
    });
  }
});
function loadProducts(category, page, reset) {
  const loader = document.querySelector(".product-tabs__loader");
  const productGrid = document.getElementById("product-grid");
  const loadMoreBtn = document.getElementById("load-more-products");
  window.productTabs.loading = true;
  loader.style.display = "block";
  loadMoreBtn.textContent = "Cargando...";
  loadMoreBtn.disabled = true;
  if (reset) {
    productGrid.style.display = "none";
    productGrid.classList.remove("in");
    loadMoreBtn.style.display = "none";
  } else {
    loader.style.display = "none";
  }
  fetch(toledano_vars.ajaxurl, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: new URLSearchParams({
      action: "load_products",
      category: category,
      page: page
    })
  }).then(response => response.json()).then(data => {
    loader.style.display = "none";
    loadMoreBtn.textContent = "Cargar más productos";
    window.productTabs.loading = false;
    loadMoreBtn.disabled = false;
    if (reset) {
      productGrid.innerHTML = data.html;
      productGrid.style.display = "flex";
      setTimeout(() => {
        productGrid.classList.add("in");
      }, 50);
    } else {
      productGrid.innerHTML += data.html;
    }

    // Verificar si hay más productos
    if (data.has_more_products === false) {
      window.productTabs.noMoreProducts = true;
      loadMoreBtn.style.display = "none";
    } else {
      loadMoreBtn.style.display = "block";
    }
  }).catch(error => {
    console.error("Error al cargar productos:", error);
    loader.style.display = "none";
    window.productTabs.loading = false;
    // Restaurar visibilidad en caso de error
    if (reset) {
      productGrid.style.opacity = "1";
    }
  });
}
const loadMoreBtn = document.getElementById("load-more-category-products");
if (loadMoreBtn) {
  loadMoreBtn.addEventListener("click", function () {
    const button = this;
    const category = button.dataset.category;
    let page = parseInt(button.dataset.page, 10);
    page++;

    // Estado de carga
    button.textContent = "Cargando...";
    button.disabled = true;

    // Realizar petición AJAX
    fetch(toledano_vars.ajaxurl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        action: "load_products",
        category: category,
        page: page
      })
    }).then(response => response.json()).then(data => {
      // Añadir nuevos productos
      const productsContainer = document.getElementById("products-container");
      productsContainer.insertAdjacentHTML("beforeend", data.html);

      // Actualizar estado del botón
      button.dataset.page = page.toString();
      button.textContent = "Cargar más productos";
      button.disabled = false;

      // Ocultar botón si no hay más productos
      if (!data.has_more_products) {
        button.style.display = "none";
      }
    }).catch(error => {
      console.error("Error al cargar productos:", error);
      button.textContent = "Error al cargar. Intentar de nuevo";
      button.disabled = false;
    });
  });
}